import DWInstallationPlatforms from "../../../../contents/docs/data-warehouse/_snippets/dw-installation-platforms";
import * as React from 'react';
export default {
  DWInstallationPlatforms,
  React
};